module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-order"
  }, [_c('div', {
    staticClass: "form_container form-flex"
  }, [_c('div', {
    staticClass: "container-order"
  }, [_c('div', {
    staticClass: "chooseOrder order-block"
  }, [_c('div', {
    staticClass: "vitrina-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterValue),
      expression: "filterValue"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.filterValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipaje),
      expression: "equipaje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.equipaje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar equipaje")]), _vm._v(" "), _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('option', {
      domProps: {
        "value": luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration
      }
    }, [_vm._v(_vm._s(luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase() + luggageItem.attributes.luggage_type.attributes.name.slice(1)) + " -  " + _vm._s(luggageItem.numeration))])
  })], 2)])]), _vm._v(" "), (_vm.availableOrders.length <= 0) ? _c('div', [_c('span', {
    staticClass: "page-stats no-orders"
  }, [_vm._v("No cuenta con órdenes disponibles para este embarque")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', _vm._l((_vm.items), function(order) {
    return (order.attributes.available_items_to_package > 0) ? _c('li', {
      key: order.id
    }, [_c('cardListOrders', {
      attrs: {
        "currentOrder": order,
        "stock": order.attributes.available_items_to_package,
        "dataLocal": _vm.dataLocal,
        "equipaje": _vm.equipaje,
        "totalWeightKg": _vm.totalWeightKg
      },
      on: {
        "add-package": _vm.addPackage
      }
    })], 1) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "resumeOrder order-block"
  }, [_c('div', {
    staticClass: "vitrina-content"
  }, [_c('div', {
    staticClass: "formContent"
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tu embarque")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "30px"
    },
    on: {
      "click": _vm.openAcordion
    }
  }, [_vm._v(_vm._s(_vm.isShowAll ? 'Cerrar todo' : 'Abrir todo'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightKg.toFixed(2))) + " Kg")])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.savePackages
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.form4
    }
  }, [_vm._v("Continuar")])], 1)]), _vm._v(" "), _vm._l((_vm.dataLocal.dataLuggage.luggage_items), function(luggageItem) {
    return _c('div', [_c('div', {
      ref: "parentAcoordition",
      refInFor: true,
      staticClass: "card panel-group",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": "headingclient",
        "data-toggle": "collapse",
        "data-target": '#collapseclient' + luggageItem.numeration,
        "aria-expanded": "false",
        "aria-controls": 'collapseclient' + luggageItem.numeration
      }
    }, [_c('span', [_vm._v(_vm._s(luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase() + luggageItem.attributes.luggage_type.attributes.name.slice(1)) + " -  " + _vm._s(luggageItem.numeration))]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      class: _vm.isShowAll ? 'collapse show' : 'collapse',
      attrs: {
        "id": 'collapseclient' + luggageItem.numeration,
        "aria-labelledby": "headingclient"
      }
    }, [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "resumen-type"
    }, [_c('div', {
      staticClass: "vitrinaContainer"
    }, [_c('div', {
      staticClass: "vitrina"
    }, [_c('ul', _vm._l((_vm.packagesToSave), function(addedPackage) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === addedPackage.equipaje) ? _c('li', [_c('cardDeleteOrders', {
        attrs: {
          "dataOrder": addedPackage
        },
        on: {
          "quit-package": _vm.quitPackage
        }
      })], 1) : _vm._e()
    }), 0)])])])])]), _vm._v(" "), _vm._l((_vm.sumaTotalPeso), function(suma) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === suma.tipo) ? _c('div', {
        staticClass: "text-right"
      }, [_c('div', {
        staticClass: "sumaPeso"
      }, [(typeof(suma.sumaPeso) === 'undefined') ? _c('span', [_vm._v(" " + _vm._s(luggageItem.attributes.weight) + " Kg")]) : _c('span', [_vm._v(_vm._s(suma.sumaPeso.toFixed(2)) + " Kg")])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.sumaTotalPrecio), function(suma2) {
      return (luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration === suma2.tipo) ? _c('div', {
        staticClass: "text-right",
        staticStyle: {
          "margin-right": "300px"
        }
      }, [_c('div', {
        staticClass: "sumaPrecio"
      }, [(typeof(suma2.precio) === 'undefined') ? _c('span', [_vm._v(" $ 0")]) : _c('span', [_vm._v("$ " + _vm._s(suma2.precio.toFixed(2)))])])]) : _vm._e()
    })], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "formContent",
    staticStyle: {
      "margin-left": "460px"
    }
  }, [_c('div', {
    staticClass: "formNew",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalSuitcase"
    }
  }, [_c('div', {
    staticClass: "weightContent"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalWeightKg.toFixed(2))) + " Kg")])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.savePackages
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.form4
    }
  }, [_vm._v("Continuar")])], 1)])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Tus órdenes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620a8054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/form-3-create-shipment.vue
// module id = 1888
// module chunks = 1